import _ from "lodash";
import React, { Component } from "react";
import classNames from "classnames";

class FeatureIcon extends Component {
  constructor(props) {
    super(props);

    var style = props.feature.selected
      ? classNames("col-md-2", "horizontal-align-center", "box-selected")
      : classNames("col-md-2", "horizontal-align-center", "box");

    this.state = {
      selected: props.feature.selected,
      style,
    };

    this.onFeatureClick = this.onFeatureClick.bind(this);
  }

  onFeatureClick() {
    var selectedVal = !this.state.selected;
    var iconstyle;

    if (selectedVal) {
      iconstyle = classNames(
        "col-md-2",
        "horizontal-align-center",
        "box-selected"
      );
    } else {
      iconstyle = classNames("col-md-2", "horizontal-align-center", "box");
    }
    this.setState({ selected: selectedVal, style: iconstyle });
    this.props.callback({ ...this.props.feature, selected: selectedVal });
  }

  render() {
    var style = {};

    if (this.props.smallIcons) {
      style = {
        width: "100px",
        height: "80px",
        position: "relative",
      };
    }
    var iconName = this.props.feature.iconName;
    if (iconName === "Schedules") iconName = "Schedule";

    if (iconName == "Webview") iconName = "Web-View";

    var normalIconUrl = `../../style/images/icons/${iconName}.png`;
    var hoveredIconUrl = `../../style/images/icons/${iconName}-Fill.png`;
    var selectedIconUrl = `../../style/images/icons/${iconName}-White.png`;
    var icon_title = _.replace(this.props.feature.iconName, "-", " ");
    return (
      <div
        style={style}
        className={this.state.style}
        onClick={this.onFeatureClick}
      >
        <div>
          <img className="normal" src={normalIconUrl} />
          <img className="hovered" src={hoveredIconUrl} />
          <img className="selected" src={selectedIconUrl} />
          {this.state.selected ? (
            <img
              className="feature-tick"
              src="/images/v2_icons/theme-tick.png"
            />
          ) : null}
        </div>
        <div className="icon-title">{icon_title}</div>
      </div>
    );
  }
}

function mapStateToProps({}) {
  return {};
}

export default FeatureIcon;
